// TODO ALPHA remove admin once doc creation fixed to exclude Admin (also/rather, what should happen when a doc is assigned to an Admin - what should doclist show?)
/* const stages =
'client',

'created'
'client completed',
'lawyer'

*/

import {
  ADMIN,
  ADVISER,
  INDIVIDUAL,
  LAWYER,
  SINGLE_USER,
  STANDARD_BUSINESS
} from './dataAccess/accountTypes'

const docTypeStages = {
  [INDIVIDUAL.id]: ['Created'],
  [ADVISER.id]: [
    ['Created', 'Adviser'],
    'Client',
    'Client Completed',
    'Lawyer'
  ],
  [LAWYER.id]: [['Created', 'Lawyer'], 'Client', 'Client Completed', 'Lawyer'],
  [SINGLE_USER.id]: ['Created', 'Counterparty', 'Awaiting Signature'],
  [STANDARD_BUSINESS.id]: ['Created', 'Counterparty', 'Awaiting Signature']
}

const progressStagesCfg = {
  [INDIVIDUAL.id]: [{ name: 'individual', label: '', progressBarFrac: 1 }],
  [ADMIN.id]: [{ name: 'individual', label: '', progressBarFrac: 1 }],
  [ADVISER.id]: [
    {
      name: 'Adviser',
      label: 'adviser',
      progressBarFrac: 2,
      subStages: ['Created']
    },
    {
      name: 'Client',
      label: 'client',
      progressBarFrac: 3,
      subStages: ['Sent to Client', '']
    },
    { name: 'Adviser Review', label: 'adviser', progressBarFrac: 1 },
    { name: 'Lawyer Review', label: 'lawyer', progressBarFrac: 2 }
  ],
  [LAWYER.id]: [
    { name: 'Lawyer', label: 'lawyer', progressBarFrac: 2 },
    { name: 'Client', label: 'client', progressBarFrac: 3 },
    { name: 'Lawyer Review', label: 'lawyer', progressBarFrac: 2 }
  ]
}

export default {
  progressStagesCfg,
  docTypeStages
}
